(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hero entrance
  var hero = document.querySelector('.about-hero');
  if (hero) {
    requestAnimationFrame(function () { hero.classList.add('is-loaded'); });
  }

  if (reduced) return;

  // Auto-tag reveal targets
  var revealBigSelectors = [
    '.about-hero__title',
    '.about-display',
    '.about-display-ja',
    '.about-manifesto__heading',
    '.about-tradeoff__words',
    '.about-cta__heading'
  ];
  var revealSelectors = [
    '.about-section:not(.about-hero) .about-eyebrow',
    '.about-heading',
    '.about-body',
    '.about-number',
    '.about-heritage__entry',
    '.about-product',
    '.about-process__svg',
    '.about-process__note',
    '.about-heritage__quote',
    '.about-products__head-meta',
    '.about-numbers__caption',
    '.about-manifesto__body',
    '.about-tradeoff__body',
    '.about-process__intro'
  ];

  function tag(selector, cls) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (!el.classList.contains(cls)) el.classList.add(cls);
    });
  }
  revealBigSelectors.forEach(function (s) { tag(s, 'about-reveal-big'); });
  revealSelectors.forEach(function (s) { tag(s, 'about-reveal'); });

  // Stagger within groups
  function stagger(selector, step) {
    document.querySelectorAll(selector).forEach(function (parent) {
      var kids = parent.children;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].classList.contains('about-reveal')) {
          kids[i].style.setProperty('--about-delay', (i * step) + 'ms');
        }
      }
    });
  }
  stagger('.about-numbers__grid', 120);
  stagger('.about-heritage__timeline', 140);
  stagger('.about-products__grid', 100);

  // IntersectionObserver reveal
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    document.querySelectorAll('.about-reveal, .about-reveal-big').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.about-reveal, .about-reveal-big').forEach(function (el) { el.classList.add('is-in'); });
  }

  // ===== Counter animation on numbers =====
  function animateCount(el) {
    var text = el.textContent.trim();
    var m = text.match(/^([^\d\-.]*)([-\d.,]+)(.*)$/);
    if (!m) return;
    var prefix = m[1] || '';
    var numStr = m[2];
    var suffix = m[3] || '';
    var hasComma = numStr.indexOf(',') !== -1;
    var decimals = (numStr.split('.')[1] || '').length;
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (!isFinite(target)) return;
    var start = performance.now();
    var dur = 1800;
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (hasComma) {
        var parts = s.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        s = parts.join('.');
      }
      return prefix + s + suffix;
    }
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function tick(now) {
      var t = Math.min((now - start) / dur, 1);
      var v = target * ease(t);
      el.textContent = fmt(v);
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = fmt(target);
    }
    el.textContent = fmt(0);
    requestAnimationFrame(tick);
  }

  var numberValues = document.querySelectorAll('.about-number__value');
  if (numberValues.length && 'IntersectionObserver' in window) {
    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animateCount(e.target);
          counterIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    numberValues.forEach(function (el) { counterIO.observe(el); });
  }

  // ===== SVG stroke drawing on process flowchart =====
  var processSvg = document.querySelector('.about-process__svg svg');
  if (processSvg && 'IntersectionObserver' in window) {
    var connectors = processSvg.querySelectorAll(':scope > line');
    connectors.forEach(function (line) {
      var x1 = parseFloat(line.getAttribute('x1'));
      var y1 = parseFloat(line.getAttribute('y1'));
      var x2 = parseFloat(line.getAttribute('x2'));
      var y2 = parseFloat(line.getAttribute('y2'));
      var len = Math.hypot(x2 - x1, y2 - y1);
      line.style.strokeDasharray = len;
      line.style.strokeDashoffset = len;
      line.style.transition = 'stroke-dashoffset 1.6s cubic-bezier(0.22, 1, 0.36, 1)';
    });
    var strokeIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          connectors.forEach(function (line, i) {
            line.style.transitionDelay = (i * 80) + 'ms';
            line.style.strokeDashoffset = '0';
          });
          strokeIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    strokeIO.observe(processSvg);
  }

  // ===== Photo break parallax =====
  var photoBreaks = document.querySelectorAll('.about-photobreak');
  if (photoBreaks.length) {
    var pbTicking = false;
    function pbUpdate() {
      var wh = window.innerHeight;
      photoBreaks.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > wh) return;
        var progress = (wh - r.top) / (wh + r.height);
        var p = Math.max(0, Math.min(1, progress));
        var img = el.querySelector('.about-photobreak__img');
        if (img) {
          var y = (p - 0.5) * 80;
          img.style.transform = 'translate3d(0,' + y + 'px,0) scale(1.12)';
        }
      });
      pbTicking = false;
    }
    window.addEventListener('scroll', function () {
      if (!pbTicking) { requestAnimationFrame(pbUpdate); pbTicking = true; }
    }, { passive: true });
    pbUpdate();
  }

  // Hero parallax
  var heroBg = document.querySelector('.about-hero__bg');
  if (heroBg && hero) {
    var ticking = false;
    function update() {
      var r = hero.getBoundingClientRect();
      var y = Math.max(-r.top, 0);
      var max = hero.offsetHeight;
      var p = Math.min(y / max, 1) * 80;
      heroBg.style.setProperty('--about-parallax', p + 'px');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }
})();
